module.exports = __webpack_public_path__ + "static/media/BG_splash_screens_web.ec19a141.png";